"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DynamicResize = exports.StatusDot = exports.TitleOfPane = void 0;
const classnames_1 = __importDefault(require("classnames"));
const react_1 = __importDefault(require("react"));
const styles = __importStar(require("./style/Components"));
const re_resizable_1 = require("re-resizable");
exports.TitleOfPane = ({ children }) => react_1.default.createElement("div", { className: styles.TitleOfPane }, children);
exports.StatusDot = ({ status }) => (react_1.default.createElement("div", { className: classnames_1.default(styles.StatusDot, {
        [status]: true,
    }) }));
exports.DynamicResize = ({ children, width, resizeCallback, disabledClass }) => {
    if (disabledClass) {
        return react_1.default.createElement("div", { className: disabledClass }, children);
    }
    return (react_1.default.createElement(re_resizable_1.Resizable, { defaultSize: {
            width,
            height: '100%',
        }, style: {
            display: 'flex',
            flexFlow: 'row nowrap',
            zIndex: 3,
        }, onResize: resizeCallback, maxWidth: "100%", minWidth: "1" }, children));
};
